/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function( $ ) {
    "use strict";

    $( document ).ready(function() {
	$('#form-field-field_bece8b3').on('change', function(){
	     if ($(this).val() === 'Journaliste') {
		 // Redirigez l'internaute vers l'URL spécifiée
		 window.location.href = '/espace-presse/';		 
             }
	});
	$('#menu-nom').click(function(){
	    $('.elementor-location-header .elementor-menu-toggle').trigger('click');
	});
	
	$('.filter button').click(function(e){
	    var termid = $(this).data('term_id');
	    $('.filter button').addClass('inactive');
	    $(this).removeClass('inactive');

	    if (termid == 0){
		$('.lst-publications > div').addClass('active');
		$('.lst-articles > div').addClass('active');
	    }
	    else{
		$('.lst-publications > div').removeClass('active');
		$('.lst-publications > div.term-'+termid).addClass('active');
		$('.lst-articles > div').removeClass('active');
		$('.lst-articles > div.term-'+termid).addClass('active');
	    }
	});

	// anchors with menu
	const anchors = document.querySelectorAll('a[href*="#"]:not([href^="#elementor"]');
	for (let anchor of anchors) {
            anchor.addEventListener('click', function(event) {
		event.preventDefault(); // Empêche le comportement par défaut du clic sur le lien
		event.stopPropagation();
		
		const targetId = this.getAttribute('href').substr(1); // Récupère l'identifiant de l'ancre
		const targetElement = document.getElementById(targetId); // Récupère l'élément cible
		
		if (targetElement) {
                    const targetOffset = targetElement.offsetTop; // Récupère la position de l'élément par rapport au haut de la page
                    const scrolledY = window.scrollY || window.pageYOffset; // Récupère la position actuelle de défilement
		    console.log(targetOffset, targetId);
                    // Anime le défilement
                    window.scrollTo({
			top: targetOffset - 80, // Déplace la position de défilement
			behavior: 'smooth' // Anime le défilement
                    });
		}
            });
	}

	// ajout en plus sous menu
//	$('.menu-item-has-children.menu-item-29').prepend('<a href="/">Accueil</a>');
	$('.menu-item-has-children.menu-item-44').append('<a href="/espace-presse/">Espace presse</a>');

	
	$('#searchandfilter').on('change', function(){
	    $(this).submit();
	});
	
	$('#searchandfilter').on('submit', function(event) {
            event.preventDefault(); // Prevent the default form submission
	    var urlajax = $(this).data('url');
	    var formData = new FormData(this);
	    formData.append('action', 'get_latest_articles');

            $.ajax({
		url: urlajax,
		method: 'POST',
		data: formData,
		processData: false, 
                contentType: false, 
		success: function(response) {
                    // Faire quelque chose avec la réponse (par exemple, l'insérer dans une div)
                    $('#result').html(response);
		},
		error: function(xhr, status, error) {
                    console.error(xhr.responseText);
		}
            });
	});

	if ($('#searchandfilter')){
	    $('#searchandfilter').submit();
	}
	
    });
    
}( jQuery ) );
